module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('BasePage', {
    attrs: {
      "container": false
    }
  }, [(_vm.loading) ? _c('Loader') : _c('section', [_c('div', {
    staticClass: "columns is-mobile"
  }, [(_vm.step === 0) ? _c('div', {
    staticClass: "column is-6 is-offset-3"
  }, [_c('section', {
    attrs: {
      "id": "intro"
    }
  }, [_c('h1', {
    staticClass: "title is-1 exercise--title"
  }, [_vm._v(_vm._s(_vm.exercise != null ? _vm.exercise.title : 'huh?'))]), _vm._v(" "), _c('p', [_vm._v("Welcome to DIY Flex! This program is designed to help you leverage your classroom video to grow your teaching practice and drive your professional development.")]), _vm._v(" "), _c('p', [_vm._v("Working through this process with a partner will allow you to earn "), _c('strong', [_vm._v("1 Academic Ladder Credit (ALC)")]), _vm._v(",which can be used for salary lane advancement. To learn more about ALCs, please click here.")]), _vm._v(" "), _c('p', [_vm._v("If you have any questions or would like to register, please reach out to "), _c('a', {
    attrs: {
      "href": "mailto:kelly@classforward.com"
    }
  }, [_vm._v("kelly@classforward.com")])])]), _vm._v(" "), _c('div', {
    staticClass: "menu-list"
  }, [_c('div', {
    on: {
      "click": function($event) {
        _vm.saveAndAdvance(1)
      }
    }
  }, [_vm._v("Introductory Reflection\n            "), (_vm.completionStatus.introReflectionComplete) ? _c('CircledCheckMarkIcon', {
    staticClass: "completed--icon"
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    on: {
      "click": function($event) {
        _vm.displaySR = !_vm.displaySR
      }
    }
  }, [_vm._v("Self-Reflection (x3)\n            "), (_vm.completionStatus.selfReflection1Complete) ? _c('CircledCheckMarkIcon', {
    staticClass: "completed--icon"
  }) : _vm._e(), _vm._v(" "), _c('ChevronIcon', {
    class: {
      'upside-down': _vm.displaySR
    }
  })], 1), _vm._v(" "), (_vm.displaySR) ? _c('section', {
    staticClass: "drop-down"
  }, [_c('ExerciseDropdown', {
    attrs: {
      "isCoaching": false,
      "saveAndAdvance": _vm.saveAndAdvance,
      "saveAndAdvanceIndex": 2,
      "title": 'Self Reflection 1',
      "videoComplete": this.exercise.self_reflection1_video,
      "commentComplete": this.exercise.self_reflection1_comments,
      "reflectionComplete": this.selfReflection1
    }
  }), _vm._v(" "), _c('ExerciseDropdown', {
    attrs: {
      "isCoaching": false,
      "saveAndAdvance": _vm.saveAndAdvance,
      "saveAndAdvanceIndex": 3,
      "title": 'Self Reflection 2',
      "videoComplete": this.exercise.self_reflection2_video,
      "commentComplete": this.exercise.self_reflection2_comments,
      "reflectionComplete": this.selfReflection2
    }
  }), _vm._v(" "), _c('ExerciseDropdown', {
    attrs: {
      "isCoaching": false,
      "saveAndAdvance": _vm.saveAndAdvance,
      "saveAndAdvanceIndex": 4,
      "title": 'Self Reflection 3',
      "videoComplete": this.exercise.self_reflection3_video,
      "commentComplete": this.exercise.self_reflection3_comments,
      "reflectionComplete": this.selfReflection3
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    on: {
      "click": function($event) {
        _vm.displayCC = !_vm.displayCC
      }
    }
  }, [_vm._v("Coaching Conversation (x3)\n            "), (_vm.completionStatus.coachingConversation1Complete) ? _c('CircledCheckMarkIcon', {
    staticClass: "completed--icon"
  }) : _vm._e(), _vm._v(" "), _c('ChevronIcon', {
    class: {
      'upside-down': _vm.displayCC
    }
  })], 1), _vm._v(" "), (_vm.displayCC) ? _c('section', {
    staticClass: "drop-down"
  }, [_c('ExerciseDropdown', {
    attrs: {
      "isCoaching": true,
      "saveAndAdvance": _vm.saveAndAdvance,
      "saveAndAdvanceIndex": 5,
      "title": 'Coaching Conversation 1',
      "videoComplete": this.exercise.coaching_conversation1_video,
      "commentComplete": this.exercise.coaching_conversation1_comments,
      "reflectionComplete": this.coachingConversation1Reflection,
      "coachingComplete": this.coachingConversation1Coaching
    }
  }), _vm._v(" "), _c('ExerciseDropdown', {
    attrs: {
      "isCoaching": true,
      "saveAndAdvance": _vm.saveAndAdvance,
      "saveAndAdvanceIndex": 6,
      "title": 'Coaching Conversation 2',
      "videoComplete": this.exercise.coaching_conversation2_video,
      "commentComplete": this.exercise.coaching_conversation2_comments,
      "reflectionComplete": this.coachingConversation2Reflection,
      "coachingComplete": this.coachingConversation2Coaching
    }
  }), _vm._v(" "), _c('ExerciseDropdown', {
    attrs: {
      "isCoaching": true,
      "saveAndAdvance": _vm.saveAndAdvance,
      "saveAndAdvanceIndex": 7,
      "title": 'Coaching Conversation 3',
      "videoComplete": this.exercise.coaching_conversation3_video,
      "commentComplete": this.exercise.coaching_conversation3_comments,
      "reflectionComplete": this.coachingConversation3Reflection,
      "coachingComplete": this.coachingConversation3Coaching
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    on: {
      "click": function($event) {
        _vm.saveAndAdvance(8)
      }
    }
  }, [_vm._v("Final Reflection\n            "), (_vm.completionStatus.finalReflectionComplete) ? _c('CircledCheckMarkIcon', {
    staticClass: "completed--icon"
  }) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "column is-half is-offset-one-quarter"
  }, [(_vm.step === 1) ? [_c('div', {
    staticClass: "box"
  }, [_c('section', {
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between"
    }
  }, [_c('h1', [_vm._v("INTRODUCTORY REFLECTION")])]), _vm._v(" "), _c('p', [_vm._v("Given your work last year in DIY, name "), _c('strong', [_vm._v("your instructional improvement goal")]), _vm._v(" for DIY Flex. Clearly state your goal, provide your rationale for choosing this based on previous analysis of instruction, and attend to these guiding questions.")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("How would this create a more equitable learning environment?")]), _vm._v(" "), _c('li', [_vm._v("How does this develop a student-centered and collaborative classroom environment?")]), _vm._v(" "), _c('li', [_vm._v("How will this advance student understanding of the content?")])]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.exercise.intro_reflection_text),
      expression: "exercise.intro_reflection_text"
    }],
    staticClass: "textarea",
    domProps: {
      "value": (_vm.exercise.intro_reflection_text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.exercise, "intro_reflection_text", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('span', [_c('button', {
    staticClass: "button is-info",
    on: {
      "click": function($event) {
        _vm.saveExercise()
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        _vm.saveAndAdvance(0)
      }
    }
  }, [_vm._v("Home")])])] : _vm._e(), _vm._v(" "), (_vm.step === 2) ? [_c('div', {
    staticClass: "box"
  }, [_c('section', {
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between"
    }
  }, [_c('h1', {
    attrs: {
      "data-balloon": this.toolTipSR,
      "data-balloon-pos": "down",
      "data-balloon-break": ""
    }
  }, [_vm._v("SELF-REFLECTION 1")])]), _vm._v(" "), _c('span', [_vm._v("Video: (select from drop-down)")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.exercise.self_reflection1_video),
      expression: "exercise.self_reflection1_video"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.exercise, "self_reflection1_video", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.videos), function(option) {
    return _c('option', {
      domProps: {
        "value": option.id
      }
    }, [_vm._v("\n                    " + _vm._s(option.title) + "\n                  ")])
  }))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.exercise.self_reflection1_comments),
      expression: "exercise.self_reflection1_comments"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.exercise.self_reflection1_comments) ? _vm._i(_vm.exercise.self_reflection1_comments, null) > -1 : (_vm.exercise.self_reflection1_comments)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.exercise.self_reflection1_comments,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.exercise, "self_reflection1_comments", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.exercise, "self_reflection1_comments", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.exercise, "self_reflection1_comments", $$c)
        }
      }
    }
  }), _vm._v(" Check this box to indicate that you have made at least 5 comments on your video.\n\n              "), _c('p', [_vm._v("What did you notice?")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.exercise.self_reflection1_text1),
      expression: "exercise.self_reflection1_text1"
    }],
    staticClass: "textarea",
    domProps: {
      "value": (_vm.exercise.self_reflection1_text1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.exercise, "self_reflection1_text1", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('p', [_vm._v("In the video artifact, where do you see examples of your practice moving towards your instructional goal?")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.exercise.self_reflection1_text2),
      expression: "exercise.self_reflection1_text2"
    }],
    staticClass: "textarea",
    domProps: {
      "value": (_vm.exercise.self_reflection1_text2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.exercise, "self_reflection1_text2", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('p', [_vm._v("Analyze one instructional move you captured and what adjustment you would make to move closer to your stated instructional improvement goal.")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.exercise.self_reflection1_text3),
      expression: "exercise.self_reflection1_text3"
    }],
    staticClass: "textarea",
    domProps: {
      "value": (_vm.exercise.self_reflection1_text3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.exercise, "self_reflection1_text3", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('p', [_vm._v("How has this reflection impacted your thinking about your teaching moving forward?")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.exercise.self_reflection1_text4),
      expression: "exercise.self_reflection1_text4"
    }],
    staticClass: "textarea",
    domProps: {
      "value": (_vm.exercise.self_reflection1_text4)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.exercise, "self_reflection1_text4", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('p', [_vm._v("What will you focus on for the next round of videotaping and what is at least one specific next step you will take to move closer to your goal?")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.exercise.self_reflection1_text5),
      expression: "exercise.self_reflection1_text5"
    }],
    staticClass: "textarea",
    domProps: {
      "value": (_vm.exercise.self_reflection1_text5)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.exercise, "self_reflection1_text5", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('span', [_c('button', {
    staticClass: "button is-info",
    on: {
      "click": function($event) {
        _vm.saveExercise()
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        _vm.saveAndAdvance(0)
      }
    }
  }, [_vm._v("Home")])])] : _vm._e(), _vm._v(" "), (_vm.step === 3) ? [_c('div', {
    staticClass: "box"
  }, [_c('section', {
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between"
    }
  }, [_c('h1', {
    attrs: {
      "data-balloon": this.toolTipSR,
      "data-balloon-pos": "down",
      "data-balloon-break": ""
    }
  }, [_vm._v("SELF-REFLECTION 2")])]), _vm._v(" "), _c('span', [_vm._v("Video: (select from drop-down)")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.exercise.self_reflection2_video),
      expression: "exercise.self_reflection2_video"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.exercise, "self_reflection2_video", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.videos), function(option) {
    return _c('option', {
      domProps: {
        "value": option.id
      }
    }, [_vm._v("\n                    " + _vm._s(option.title) + "\n                  ")])
  }))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.exercise.self_reflection2_comments),
      expression: "exercise.self_reflection2_comments"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.exercise.self_reflection2_comments) ? _vm._i(_vm.exercise.self_reflection2_comments, null) > -1 : (_vm.exercise.self_reflection2_comments)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.exercise.self_reflection2_comments,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.exercise, "self_reflection2_comments", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.exercise, "self_reflection2_comments", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.exercise, "self_reflection2_comments", $$c)
        }
      }
    }
  }), _vm._v(" Check this box to indicate that you have made at least 5 comments on your video.\n\n              "), _c('p', [_vm._v("What did you notice?")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.exercise.self_reflection2_text1),
      expression: "exercise.self_reflection2_text1"
    }],
    staticClass: "textarea",
    domProps: {
      "value": (_vm.exercise.self_reflection2_text1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.exercise, "self_reflection2_text1", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('p', [_vm._v("In the video artifact, where do you see examples of your practice moving towards your instructional goal?")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.exercise.self_reflection2_text2),
      expression: "exercise.self_reflection2_text2"
    }],
    staticClass: "textarea",
    domProps: {
      "value": (_vm.exercise.self_reflection2_text2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.exercise, "self_reflection2_text2", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('p', [_vm._v("Analyze one instructional move you captured and what adjustment you would make to move closer to your stated instructional improvement goal.")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.exercise.self_reflection2_text3),
      expression: "exercise.self_reflection2_text3"
    }],
    staticClass: "textarea",
    domProps: {
      "value": (_vm.exercise.self_reflection2_text3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.exercise, "self_reflection2_text3", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('p', [_vm._v("How has this reflection impacted your thinking about your teaching moving forward?")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.exercise.self_reflection2_text4),
      expression: "exercise.self_reflection2_text4"
    }],
    staticClass: "textarea",
    domProps: {
      "value": (_vm.exercise.self_reflection2_text4)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.exercise, "self_reflection2_text4", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('p', [_vm._v("What will you focus on for the next round of videotaping and what is at least one specific next step you will take to move closer to your goal?")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.exercise.self_reflection2_text5),
      expression: "exercise.self_reflection2_text5"
    }],
    staticClass: "textarea",
    domProps: {
      "value": (_vm.exercise.self_reflection2_text5)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.exercise, "self_reflection2_text5", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('span', [_c('button', {
    staticClass: "button is-info",
    on: {
      "click": function($event) {
        _vm.saveExercise()
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        _vm.saveAndAdvance(0)
      }
    }
  }, [_vm._v("Home")])])] : _vm._e(), _vm._v(" "), (_vm.step === 4) ? [_c('div', {
    staticClass: "box"
  }, [_c('section', {
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between"
    }
  }, [_c('h1', {
    attrs: {
      "data-balloon": this.toolTipSR,
      "data-balloon-pos": "down",
      "data-balloon-break": ""
    }
  }, [_vm._v("SELF-REFLECTION 3")])]), _vm._v(" "), _c('span', [_vm._v("Video: (select from drop-down)")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.exercise.self_reflection3_video),
      expression: "exercise.self_reflection3_video"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.exercise, "self_reflection3_video", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.videos), function(option) {
    return _c('option', {
      domProps: {
        "value": option.id
      }
    }, [_vm._v("\n                    " + _vm._s(option.title) + "\n                  ")])
  }))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.exercise.self_reflection3_comments),
      expression: "exercise.self_reflection3_comments"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.exercise.self_reflection3_comments) ? _vm._i(_vm.exercise.self_reflection3_comments, null) > -1 : (_vm.exercise.self_reflection3_comments)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.exercise.self_reflection3_comments,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.exercise, "self_reflection3_comments", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.exercise, "self_reflection3_comments", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.exercise, "self_reflection3_comments", $$c)
        }
      }
    }
  }), _vm._v(" Check this box to indicate that you have made at least 5 comments on your video.\n\n              "), _c('p', [_vm._v("What did you notice?")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.exercise.self_reflection3_text1),
      expression: "exercise.self_reflection3_text1"
    }],
    staticClass: "textarea",
    domProps: {
      "value": (_vm.exercise.self_reflection3_text1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.exercise, "self_reflection3_text1", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('p', [_vm._v("In the video artifact, where do you see examples of your practice moving towards your instructional goal?")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.exercise.self_reflection3_text2),
      expression: "exercise.self_reflection3_text2"
    }],
    staticClass: "textarea",
    domProps: {
      "value": (_vm.exercise.self_reflection3_text2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.exercise, "self_reflection3_text2", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('p', [_vm._v("Analyze one instructional move you captured and what adjustment you would make to move closer to your stated instructional improvement goal.")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.exercise.self_reflection3_text3),
      expression: "exercise.self_reflection3_text3"
    }],
    staticClass: "textarea",
    domProps: {
      "value": (_vm.exercise.self_reflection3_text3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.exercise, "self_reflection3_text3", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('p', [_vm._v("How has this reflection impacted your thinking about your teaching moving forward?")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.exercise.self_reflection3_text4),
      expression: "exercise.self_reflection3_text4"
    }],
    staticClass: "textarea",
    domProps: {
      "value": (_vm.exercise.self_reflection3_text4)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.exercise, "self_reflection3_text4", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('span', [_c('button', {
    staticClass: "button is-info",
    on: {
      "click": function($event) {
        _vm.saveExercise()
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        _vm.saveAndAdvance(0)
      }
    }
  }, [_vm._v("Home")])])] : _vm._e(), _vm._v(" "), (_vm.step === 5) ? [_c('div', {
    staticClass: "box"
  }, [_c('section', {
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between"
    }
  }, [_c('h1', [_vm._v("COACHING CONVERSATION 1")])]), _vm._v(" "), _c('span', [_c('h2', [_vm._v("Video")]), _vm._v("(select from drop-down)")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.exercise.coaching_conversation1_video),
      expression: "exercise.coaching_conversation1_video"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.exercise, "coaching_conversation1_video", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.videos), function(option) {
    return _c('option', {
      domProps: {
        "value": option.id
      }
    }, [_vm._v("\n                    " + _vm._s(option.title) + "\n                  ")])
  }))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.exercise.coaching_conversation1_comments1),
      expression: "exercise.coaching_conversation1_comments1"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.exercise.coaching_conversation1_comments1) ? _vm._i(_vm.exercise.coaching_conversation1_comments1, null) > -1 : (_vm.exercise.coaching_conversation1_comments1)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.exercise.coaching_conversation1_comments1,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.exercise, "coaching_conversation1_comments1", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.exercise, "coaching_conversation1_comments1", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.exercise, "coaching_conversation1_comments1", $$c)
        }
      }
    }
  }), _vm._v(" Check this box to indicate that you have made at least 5 comments on your video.\n              "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.exercise.coaching_conversation1_comments2),
      expression: "exercise.coaching_conversation1_comments2"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.exercise.coaching_conversation1_comments2) ? _vm._i(_vm.exercise.coaching_conversation1_comments2, null) > -1 : (_vm.exercise.coaching_conversation1_comments2)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.exercise.coaching_conversation1_comments2,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.exercise, "coaching_conversation1_comments2", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.exercise, "coaching_conversation1_comments2", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.exercise, "coaching_conversation1_comments2", $$c)
        }
      }
    }
  }), _vm._v(" Check this box to indicate that your partner has made at least 5 comments on your video.\n\n              "), _c('h2', [_vm._v("COACHING CONVERSATION")]), _vm._v(" "), _c('p', [_vm._v("What did you and your partner notice? Complete the coaching conversation template below (with 2-4 statements per category).")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "display": "inline"
    }
  }, [_vm._v("Clarifying questions and/or statements ")]), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://docs.google.com/document/d/13erXndBfz1BfT2OEG0EQIZkKgg9BSN_sOLcnXKmAFPo/edit?ts=5d30733d#bookmark=id.p6r3hqbkicun"
    }
  }, [_vm._v("(More Info)")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.exercise.coaching_conversation1_text1),
      expression: "exercise.coaching_conversation1_text1"
    }],
    staticClass: "textarea",
    domProps: {
      "value": (_vm.exercise.coaching_conversation1_text1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.exercise, "coaching_conversation1_text1", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "display": "inline"
    }
  }, [_vm._v("Value statements ")]), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://docs.google.com/document/d/13erXndBfz1BfT2OEG0EQIZkKgg9BSN_sOLcnXKmAFPo/edit?ts=5d30733d#bookmark=id.660e5nrz8npq"
    }
  }, [_vm._v("(More Info)")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.exercise.coaching_conversation1_text2),
      expression: "exercise.coaching_conversation1_text2"
    }],
    staticClass: "textarea",
    domProps: {
      "value": (_vm.exercise.coaching_conversation1_text2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.exercise, "coaching_conversation1_text2", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "display": "inline"
    }
  }, [_vm._v("Reflective questions or possibilities ")]), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://docs.google.com/document/d/13erXndBfz1BfT2OEG0EQIZkKgg9BSN_sOLcnXKmAFPo/edit?ts=5d30733d#bookmark=id.46bvyxoj18gu"
    }
  }, [_vm._v("(More Info)")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.exercise.coaching_conversation1_text3),
      expression: "exercise.coaching_conversation1_text3"
    }],
    staticClass: "textarea",
    domProps: {
      "value": (_vm.exercise.coaching_conversation1_text3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.exercise, "coaching_conversation1_text3", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('h2', [_vm._v("REFLECTION")]), _vm._v(" "), _c('p', [_vm._v("Analyze one instructional move you captured and what adjustment you would make to move closer to your stated goal.")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.exercise.coaching_conversation1_text4),
      expression: "exercise.coaching_conversation1_text4"
    }],
    staticClass: "textarea",
    domProps: {
      "value": (_vm.exercise.coaching_conversation1_text4)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.exercise, "coaching_conversation1_text4", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('p', [_vm._v("How has this coaching conversation impacted your thinking moving forward?")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.exercise.coaching_conversation1_text5),
      expression: "exercise.coaching_conversation1_text5"
    }],
    staticClass: "textarea",
    domProps: {
      "value": (_vm.exercise.coaching_conversation1_text5)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.exercise, "coaching_conversation1_text5", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('p', [_vm._v("Based on this coaching conversation, what will you focus on for the next round of videotaping and what is at least one specific next step you will take to move closer to your goal?")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.exercise.coaching_conversation1_text6),
      expression: "exercise.coaching_conversation1_text6"
    }],
    staticClass: "textarea",
    domProps: {
      "value": (_vm.exercise.coaching_conversation1_text6)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.exercise, "coaching_conversation1_text6", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('span', [_c('button', {
    staticClass: "button is-info",
    on: {
      "click": function($event) {
        _vm.saveExercise()
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        _vm.saveAndAdvance(0)
      }
    }
  }, [_vm._v("Home")])])] : _vm._e(), _vm._v(" "), (_vm.step === 6) ? [_c('div', {
    staticClass: "box"
  }, [_c('section', {
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between"
    }
  }, [_c('h1', [_vm._v("COACHING CONVERSATION 2")])]), _vm._v(" "), _c('span', [_c('h2', [_vm._v("Video")]), _vm._v("(select from drop-down)")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.exercise.coaching_conversation2_video),
      expression: "exercise.coaching_conversation2_video"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.exercise, "coaching_conversation2_video", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.videos), function(option) {
    return _c('option', {
      domProps: {
        "value": option.id
      }
    }, [_vm._v("\n                    " + _vm._s(option.title) + "\n                  ")])
  }))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.exercise.coaching_conversation2_comments1),
      expression: "exercise.coaching_conversation2_comments1"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.exercise.coaching_conversation2_comments1) ? _vm._i(_vm.exercise.coaching_conversation2_comments1, null) > -1 : (_vm.exercise.coaching_conversation2_comments1)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.exercise.coaching_conversation2_comments1,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.exercise, "coaching_conversation2_comments1", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.exercise, "coaching_conversation2_comments1", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.exercise, "coaching_conversation2_comments1", $$c)
        }
      }
    }
  }), _vm._v(" Check this box to indicate that you have made at least 5 comments on your video.\n              "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.exercise.coaching_conversation2_comments2),
      expression: "exercise.coaching_conversation2_comments2"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.exercise.coaching_conversation2_comments2) ? _vm._i(_vm.exercise.coaching_conversation2_comments2, null) > -1 : (_vm.exercise.coaching_conversation2_comments2)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.exercise.coaching_conversation2_comments2,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.exercise, "coaching_conversation2_comments2", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.exercise, "coaching_conversation2_comments2", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.exercise, "coaching_conversation2_comments2", $$c)
        }
      }
    }
  }), _vm._v(" Check this box to indicate that your partner has made at least 5 comments on your video.\n\n              "), _c('h2', [_vm._v("COACHING CONVERSATION")]), _vm._v(" "), _c('p', [_vm._v("What did you and your partner notice? Complete the coaching conversation template below (with 2-4 statements per category).")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "display": "inline"
    }
  }, [_vm._v("Clarifying questions and/or statements ")]), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://docs.google.com/document/d/13erXndBfz1BfT2OEG0EQIZkKgg9BSN_sOLcnXKmAFPo/edit?ts=5d30733d#bookmark=id.p6r3hqbkicun"
    }
  }, [_vm._v("(More Info)")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.exercise.coaching_conversation2_text1),
      expression: "exercise.coaching_conversation2_text1"
    }],
    staticClass: "textarea",
    domProps: {
      "value": (_vm.exercise.coaching_conversation2_text1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.exercise, "coaching_conversation2_text1", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "display": "inline"
    }
  }, [_vm._v("Value statements ")]), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://docs.google.com/document/d/13erXndBfz1BfT2OEG0EQIZkKgg9BSN_sOLcnXKmAFPo/edit?ts=5d30733d#bookmark=id.660e5nrz8npq"
    }
  }, [_vm._v("(More Info)")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.exercise.coaching_conversation2_text2),
      expression: "exercise.coaching_conversation2_text2"
    }],
    staticClass: "textarea",
    domProps: {
      "value": (_vm.exercise.coaching_conversation2_text2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.exercise, "coaching_conversation2_text2", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "display": "inline"
    }
  }, [_vm._v("Reflective questions or possibilities ")]), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://docs.google.com/document/d/13erXndBfz1BfT2OEG0EQIZkKgg9BSN_sOLcnXKmAFPo/edit?ts=5d30733d#bookmark=id.46bvyxoj18gu"
    }
  }, [_vm._v("(More Info)")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.exercise.coaching_conversation2_text3),
      expression: "exercise.coaching_conversation2_text3"
    }],
    staticClass: "textarea",
    domProps: {
      "value": (_vm.exercise.coaching_conversation2_text3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.exercise, "coaching_conversation2_text3", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('h2', [_vm._v("REFLECTION")]), _vm._v(" "), _c('p', [_vm._v("Analyze one instructional move you captured and what adjustment you would make to move closer to your stated goal.")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.exercise.coaching_conversation2_text4),
      expression: "exercise.coaching_conversation2_text4"
    }],
    staticClass: "textarea",
    domProps: {
      "value": (_vm.exercise.coaching_conversation2_text4)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.exercise, "coaching_conversation2_text4", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('p', [_vm._v("How has this coaching conversation impacted your thinking moving forward?")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.exercise.coaching_conversation2_text5),
      expression: "exercise.coaching_conversation2_text5"
    }],
    staticClass: "textarea",
    domProps: {
      "value": (_vm.exercise.coaching_conversation2_text5)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.exercise, "coaching_conversation2_text5", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('p', [_vm._v("Based on this coaching conversation, what will you focus on for the next round of videotaping and what is at least one specific next step you will take to move closer to your goal?")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.exercise.coaching_conversation2_text6),
      expression: "exercise.coaching_conversation2_text6"
    }],
    staticClass: "textarea",
    domProps: {
      "value": (_vm.exercise.coaching_conversation2_text6)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.exercise, "coaching_conversation2_text6", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('span', [_c('button', {
    staticClass: "button is-info",
    on: {
      "click": function($event) {
        _vm.saveExercise()
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        _vm.saveAndAdvance(0)
      }
    }
  }, [_vm._v("Home")])])] : _vm._e(), _vm._v(" "), (_vm.step === 7) ? [_c('div', {
    staticClass: "box"
  }, [_c('section', {
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between"
    }
  }, [_c('h1', [_vm._v("COACHING CONVERSATION 3")])]), _vm._v(" "), _c('span', [_c('h2', [_vm._v("Video")]), _vm._v("(select from drop-down)")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.exercise.coaching_conversation3_video),
      expression: "exercise.coaching_conversation3_video"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.exercise, "coaching_conversation3_video", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.videos), function(option) {
    return _c('option', {
      domProps: {
        "value": option.id
      }
    }, [_vm._v("\n                    " + _vm._s(option.title) + "\n                  ")])
  }))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.exercise.coaching_conversation3_comments1),
      expression: "exercise.coaching_conversation3_comments1"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.exercise.coaching_conversation3_comments1) ? _vm._i(_vm.exercise.coaching_conversation3_comments1, null) > -1 : (_vm.exercise.coaching_conversation3_comments1)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.exercise.coaching_conversation3_comments1,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.exercise, "coaching_conversation3_comments1", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.exercise, "coaching_conversation3_comments1", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.exercise, "coaching_conversation3_comments1", $$c)
        }
      }
    }
  }), _vm._v(" Check this box to indicate that you have made at least 5 comments on your video.\n              "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.exercise.coaching_conversation3_comments2),
      expression: "exercise.coaching_conversation3_comments2"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.exercise.coaching_conversation3_comments2) ? _vm._i(_vm.exercise.coaching_conversation3_comments2, null) > -1 : (_vm.exercise.coaching_conversation3_comments2)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.exercise.coaching_conversation3_comments2,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.exercise, "coaching_conversation3_comments2", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.exercise, "coaching_conversation3_comments2", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.exercise, "coaching_conversation3_comments2", $$c)
        }
      }
    }
  }), _vm._v(" Check this box to indicate that your partner has made at least 5 comments on your video.\n\n              "), _c('h2', [_vm._v("COACHING CONVERSATION")]), _vm._v(" "), _c('p', [_vm._v("What did you and your partner notice? Complete the coaching conversation template below (with 2-4 statements per category).")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "display": "inline"
    }
  }, [_vm._v("Clarifying questions and/or statements ")]), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://docs.google.com/document/d/13erXndBfz1BfT2OEG0EQIZkKgg9BSN_sOLcnXKmAFPo/edit?ts=5d30733d#bookmark=id.p6r3hqbkicun"
    }
  }, [_vm._v("(More Info)")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.exercise.coaching_conversation3_text1),
      expression: "exercise.coaching_conversation3_text1"
    }],
    staticClass: "textarea",
    domProps: {
      "value": (_vm.exercise.coaching_conversation3_text1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.exercise, "coaching_conversation3_text1", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "display": "inline"
    }
  }, [_vm._v("Value statements ")]), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://docs.google.com/document/d/13erXndBfz1BfT2OEG0EQIZkKgg9BSN_sOLcnXKmAFPo/edit?ts=5d30733d#bookmark=id.660e5nrz8npq"
    }
  }, [_vm._v("(More Info)")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.exercise.coaching_conversation3_text2),
      expression: "exercise.coaching_conversation3_text2"
    }],
    staticClass: "textarea",
    domProps: {
      "value": (_vm.exercise.coaching_conversation3_text2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.exercise, "coaching_conversation3_text2", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "display": "inline"
    }
  }, [_vm._v("Reflective questions or possibilities ")]), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://docs.google.com/document/d/13erXndBfz1BfT2OEG0EQIZkKgg9BSN_sOLcnXKmAFPo/edit?ts=5d30733d#bookmark=id.46bvyxoj18gu"
    }
  }, [_vm._v("(More Info)")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.exercise.coaching_conversation3_text3),
      expression: "exercise.coaching_conversation3_text3"
    }],
    staticClass: "textarea",
    domProps: {
      "value": (_vm.exercise.coaching_conversation3_text3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.exercise, "coaching_conversation3_text3", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('h2', [_vm._v("REFLECTION")]), _vm._v(" "), _c('p', [_vm._v("Analyze one instructional move you captured and what adjustment you would make to move closer to your stated goal.")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.exercise.coaching_conversation3_text4),
      expression: "exercise.coaching_conversation3_text4"
    }],
    staticClass: "textarea",
    domProps: {
      "value": (_vm.exercise.coaching_conversation3_text4)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.exercise, "coaching_conversation3_text4", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('p', [_vm._v("How has this coaching conversation impacted your thinking moving forward?")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.exercise.coaching_conversation2_text5),
      expression: "exercise.coaching_conversation2_text5"
    }],
    staticClass: "textarea",
    domProps: {
      "value": (_vm.exercise.coaching_conversation2_text5)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.exercise, "coaching_conversation2_text5", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('span', [_c('button', {
    staticClass: "button is-info",
    on: {
      "click": function($event) {
        _vm.saveExercise()
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        _vm.saveAndAdvance(0)
      }
    }
  }, [_vm._v("Home")])])] : _vm._e(), _vm._v(" "), (_vm.step === 8) ? [_c('div', {
    staticClass: "box"
  }, [_c('section', {
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between"
    }
  }, [_c('h1', [_vm._v("FINAL REFLECTION")])]), _vm._v(" "), _c('p', [_vm._v("Review your original goal and rationale and explain how that has evolved over time, as captured in ClassForward embedded reflections")]), _vm._v(" "), _c('h2', [_vm._v("Reflection on goal")]), _vm._v(" "), _c('p', [_vm._v("Analyze at least three instructional moves related to your goal from your most recent video")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Provide at least 2 examples of instructional adjustments based on student response (Ex. My intention was to do X; when I saw/heard students doing Y, this then made me do Z)")]), _vm._v(" "), _c('li', [_vm._v("Provide at least 1 example of an instructional adjustment you could have made based on a student response. (ex: my intention was to do X; when I saw/heard students doing Y, I did Z. An alternative could be B and the expected impact is C.)")])]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.exercise.final_reflection_text1),
      expression: "exercise.final_reflection_text1"
    }],
    staticClass: "textarea",
    domProps: {
      "value": (_vm.exercise.final_reflection_text1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.exercise, "final_reflection_text1", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('h2', [_vm._v("Reflection on practice")]), _vm._v(" "), _c('p', [_vm._v("Throughout DIY Flex, how has your practice grown toward your goal? What implications does this have for your future teaching?")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.exercise.final_reflection_text2),
      expression: "exercise.final_reflection_text2"
    }],
    staticClass: "textarea",
    domProps: {
      "value": (_vm.exercise.final_reflection_text2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.exercise, "final_reflection_text2", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "button is-info",
    on: {
      "click": function($event) {
        _vm.saveExercise()
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        _vm.saveAndAdvance(0)
      }
    }
  }, [_vm._v("Home")]), _vm._v(" "), (this.completionStatus.all) ? _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        _vm.exportToPDF()
      }
    }
  }, [_vm._v("\n              Export as PDF\n            ")]) : _vm._e()] : _vm._e()], 2)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-4d74ebcc"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Exercise.vue
// module id = 1030
// module chunks = 0